const CustomerCareIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.8125 20.9805V14.7305C23.8125 10.4157 20.3147 6.91797 16 6.91797V6.91797C11.6853 6.91797 8.1875 10.4157 8.1875 14.7305V20.9805"
        stroke="black"
        strokeWidth="1.2"
      />
      <path
        d="M23.8125 15.5117V22.1493C23.8125 23.53 22.6932 24.6493 21.3125 24.6493H16"
        stroke="black"
        strokeWidth="1.2"
      />
      <path
        d="M8.1875 16.293H10.9806L12.25 17.6614V20.9805H8.1875V16.293Z"
        stroke="black"
        strokeWidth="1.2"
      />
      <path
        d="M23.8125 16.293H21.0194L19.75 17.6614V20.9805H23.8125V16.293Z"
        stroke="black"
        strokeWidth="1.2"
      />
      <path
        d="M17.25 24H14.125V25.25H17.25V24Z"
        stroke="black"
        strokeWidth="1.3"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CustomerCareIcon
